var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7.704,
    height: 11.35
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon metro-pin",
    d: "M5.297 6.551L1.508 4.364a.972.972 0 10-.972 1.683l3.788 2.187a.972.972 0 00.973-1.683zM2.173 4.186l2.946 1.7 1-2.789-2.033-1.173-1.914 2.262zM.001 11.35L2.82 7.926l-1.263-.729zm7.338-9.794L4.813.098a.73.73 0 10-.729 1.263L6.61 2.819a.73.73 0 10.729-1.263z",
    fill: "#126bd5"
  })));
};
export default SvgPin;